import React from "react";
import { Button, Grid } from "semantic-ui-react";
import "../../styles/dashboard.scss";

const BCDashboardButtons = ({ ...props }) => {
  return (
    <Grid className="dashboard-button-group">
      <Grid.Row columns={2} className="dashboard-button-group-row">
        {props.showInverse && <Grid.Column textAlign="center">
          <Button className="dashboard-button-inverse" fluid onClick={props.handleNewProject}>
            <div>{props.inverseText}</div>
          </Button>
        </Grid.Column>}
        <Grid.Column textAlign="center">
          <Button className="dashboard-button" fluid onClick={props.handleSeeAll}>
            <div>SEE ALL</div>
          </Button>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default BCDashboardButtons;